const mediaData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20composition%20with%20warm%20red%20and%20dark%20tones%20suggesting%20entertainment%20news%20video%20thumbnail%2C%20dramatic%20lighting%2C%20abstract%20play%20button%20area%2C%20bold%20visual%20style%2C%20no%20text%2C%20no%20faces%2C%20editorial%20photography&width=800&height=450&seq=media-01-51cg&orientation=landscape',
    duration: '15:42',
    title: '2024娱乐圈年度十大震撼事件深度回顾',
    desc: '从顶流塌房到综艺内幕，逐一梳理今年最令人瞠目结舌的娱乐大事件。',
    views: '256w',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20editorial%20image%20with%20warm%20amber%20and%20dark%20red%20gradients%20suggesting%20behind%20the%20scenes%20video%20content%2C%20cinematic%20atmosphere%2C%20no%20text%2C%20no%20faces%2C%20editorial%20photography&width=800&height=450&seq=media-02-51cg&orientation=landscape',
    duration: '08:21',
    title: '网红经济背后的黑色产业链揭秘',
    desc: '深入调查网红刷量、买粉、虚假带货等灰色操作，数据触目惊心。',
    views: '189w',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20composition%20with%20crimson%20and%20deep%20black%20abstract%20shapes%2C%20suggesting%20exclusive%20interview%20and%20breaking%20news%20video%2C%20dramatic%20cinematic%20style%2C%20no%20text%2C%20no%20faces&width=800&height=450&seq=media-03-51cg&orientation=landscape',
    duration: '22:05',
    title: '独家对话：圈内资深娱记的二十年爆料生涯',
    desc: '从业二十年的娱乐记者首次公开讲述那些不为人知的行业内幕和潜规则。',
    views: '312w',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            吃瓜视频
          </h2>
          <p className="mt-2 text-sm text-foreground-500">热门爆料视频精选，深度解读娱乐八卦</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaData.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/60 rounded-lg overflow-hidden cursor-pointer hover:border-primary-200/60 transition-colors"
            >
              <div className="relative w-full" style={{ aspectRatio: '16/9' }}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 text-xs bg-black/60 text-background-50 px-2 py-0.5 rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>{item.views} 次播放
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}